/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MobileAppWalletTypeApiModel } from './mobile-app-wallet-type';

/**
 * Payment status details
 */
export interface PaymentStatusApiModel {
  /**
   * To pay amount (optional)
   */
  amount?: number | null;
  /**
   * Card details required for payment (for stripe only)
   */
  card_details_required?: boolean;
  /**
   * One time client operation token (for stripe only)
   */
  client_secret?: string;
  /**
   * Currency ISO code
   */
  currency?: string | null;
  /**
   * Customer fee amount (optional, only for \'mobile-app\' type)
   */
  customer_fee_amount?: number | null;
  /**
   * Payment error (optional)
   */
  error?: string | null;
  /**
   * Payment Id
   */
  id?: string;
  /**
   * Integration type used for payment (for stripe only)
   */
  integration_type?: PaymentStatusApiModelIntegrationTypeEnum;
  /**
   * Payment amount
   */
  invoice?: number | null;
  /**
   * External system payment identifier (optional, for stripe, 4bill, eway only)
   */
  payment_external_id?: string;
  /**
   * External system payment processing URL (optional, for 4bill, eway, stripe/checkout only)
   */
  payment_processing_url?: string;
  /**
   * Secure type
   */
  secure?: PaymentStatusApiModelSecureEnum | null;
  /**
   * Operation status
   */
  status?: PaymentStatusApiModelStatusEnum | null;
  type?: MobileAppWalletTypeApiModel;
}
export enum PaymentStatusApiModelIntegrationTypeEnum {
  Checkout = 'checkout',
  Elements = 'elements'
}
export enum PaymentStatusApiModelSecureEnum {
  None = 'none',
  Otp = 'otp',
  _3ds = '3ds'
}
export enum PaymentStatusApiModelStatusEnum {
  Inprocess = 'inprocess',
  Success = 'success',
  Fail = 'fail',
  Confirmation = 'confirmation',
  Verification = 'verification',
  Registered = 'registered',
  Canceled = 'canceled',
  Error = 'error',
  Authorized = 'authorized',
  Unknown = 'unknown'
}
